import { getFormId, getParentOrigin } from "./formParams";

let hasMarkedOpened = false;

/**
 * Marks the form link as opened. Called once the form has rendered in a
 * browser, so link-preview crawlers that only fetch the link never count.
 * The server ignores this when the link is already opened or completed.
 */
export async function markFormOpened(): Promise<void> {
  if (hasMarkedOpened) return;
  const formId = getFormId();
  const parentOrigin = getParentOrigin();
  if (!formId || !parentOrigin) return;
  hasMarkedOpened = true;

  try {
    await fetch(
      `${parentOrigin}/api/forms/sleep-history/${encodeURIComponent(formId)}`,
      {
        body: JSON.stringify({ accessedAt: Date.now(), status: "accessed" }),
        headers: { "Content-Type": "application/json" },
        keepalive: true,
        method: "PATCH",
      },
    );
  } catch (err) {
    console.warn("[SHH] Failed to mark form as opened (non-blocking):", err);
  }
}
